<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="titlepage"></a>
<a id="page_iii"></a>
<h1 class="title">The Rare Coin Score</h1>
<p class="extra-indent" id="tp01_p1"> </p>
<p class="extra-indent" id="tp01_p2"> </p>
<p class="author" id="tp01_p3">RICHARD STARK<br/><br/><i>With a New Foreword by Luc Sante</i></p>
<p class="extra-indent" id="tp01_p4"> </p>
<p class="publisher" id="tp01_p5">The University of Chicago Press</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?711a9449